module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-confirm-dialog"
  }, [_c('div', {
    staticClass: "reveal small",
    attrs: {
      "id": _vm.id
    }
  }, [_c('h2', [_vm._v("  " + _vm._s(_vm.title))]), _c('p', {
    staticClass: "lead"
  }, [_vm._v("  " + _vm._s(_vm.message))]), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2), _c('button', {
    staticClass: "button success yes",
    attrs: {
      "data-close": ""
    },
    on: {
      "click": _vm.successClick
    }
  }, [_vm._v("Yes")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "data-close": ""
    }
  }, [_vm._v("No")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ae4d6e4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/ConfirmDialog.vue
// module id = 2308
// module chunks = 1